module.exports = __webpack_public_path__ + "img/img-pregoeiro.95f1748b.svg";